import React from 'react';
import { connect } from '@cerebral/react';
import { state } from 'app/pwa/app.cerebral';
import { DaysLeft } from './elements';
import dayjs from 'dayjs';
import { useText } from 'common/hooks';

const deps = {
  challenge: state.challenge.campaign.challenge,
};

export function DayStats({ challenge }: typeof deps): React.ReactElement {
  const t = useText();

  const now = dayjs();
  const startDate = dayjs(challenge?.startDatetime);
  const endDate = dayjs(challenge?.endDatetime);

  if (!challenge || startDate?.isSame(endDate, 'day')) {
    return <DaysLeft number={'-'} textcontent={'-'} locale={t.fullLocale} />;
  }

  if (startDate?.isAfter(now)) {
    return (
      <DaysLeft
        number={startDate?.toNow(true)}
        textcontent={t('challenge.ChaMeta01.time_til_start')}
        locale={t.fullLocale}
      />
    );
  }

  if (endDate?.isBefore(now)) {
    return (
      <DaysLeft
        number={t('challenge.ChaMeta01.ended')}
        textcontent={endDate?.fromNow()}
        locale={t.fullLocale}
      />
    );
  }

  if (now.isSame(endDate, 'day')) {
    return (
      <DaysLeft
        number={endDate?.toNow(true)}
        textcontent={t('challenge.ChaMeta01.time_til_end')}
        locale={t.fullLocale}
      />
    );
  }

  return (
    <DaysLeft
      number={Number(endDate.diff(now, 'days') + 1)}
      textcontent={t('challenge.ChaMeta01.days_til_end')}
      locale={t.fullLocale}
    />
  );
}

export default connect(deps, DayStats);
